<template>
  <footer class="footer">
    <div class="container">
      <div class="footer__grid">
        <div>
          <h4>{{ company.brand }}</h4>
          <p>{{ t("footer.blurb") }}</p>
          <p>
            <a :href="`tel:${company.phoneTel}`">{{ company.phone }}</a>
          </p>
          <p v-for="mail in company.emails" :key="mail">
            <a :href="`mailto:${mail}`">{{ mail }}</a>
          </p>
          <p>{{ company.city }}</p>
        </div>
        <div>
          <h4>{{ t("footer.services") }}</h4>
          <ul>
            <li>
              <a href="#hizmetler">{{ t("services.items.web.title") }}</a>
            </li>
            <li>
              <a href="#hizmetler">{{ t("services.items.mobile.title") }}</a>
            </li>
            <li>
              <a href="#hizmetler">{{ t("services.items.crm.title") }}</a>
            </li>
            <li>
              <a href="#hizmetler">{{ t("services.items.erp.title") }}</a>
            </li>
          </ul>
        </div>
        <div>
          <h4>{{ t("footer.company") }}</h4>
          <ul>
            <li>
              <a href="#hakkimizda">{{ t("nav.about") }}</a>
            </li>
            <li>
              <a href="#paketler">{{ t("nav.packages") }}</a>
            </li>
            <li>
              <a href="#rehber">Sektörel Yazılım Rehberi</a>
            </li>
            <li>
              <a href="#iletisim">{{ t("nav.contact") }}</a>
            </li>
          </ul>
        </div>
      </div>
      <div class="footer__copy">
        © {{ year }} {{ company.brand }}. {{ t("footer.rights") }}
      </div>
    </div>
  </footer>
</template>

<script>
import { useI18n } from "vue-i18n";
import { company } from "@/data/company";

export default {
  name: "SiteFooter",
  setup() {
    const { t } = useI18n();
    return { t, company, year: new Date().getFullYear() };
  },
};
</script>
